document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabbed-bestsellers').forEach(section => {

    const tabs = section.querySelectorAll('.tb-tab');
    const panels = section.querySelectorAll('.tb-panel');
    const viewAll = section.querySelector('.tb-view-all');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {

        const handle = tab.dataset.handle;

        // Active Tab
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        // Active Panel
        panels.forEach(panel => {
          panel.classList.toggle(
            'active',
            panel.dataset.panel === handle
          );
        });

        // Update View All Link
        if (viewAll) {
          viewAll.href = `/collections/${handle}`;
        }

      });
    });

  });
});